function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { Menu } from '@deephaven/components';
import AdvancedSettingsType from "./AdvancedSettingsType.js";
import { jsx as _jsx } from "react/jsx-runtime";
function AdvancedSettingsMenu(_ref) {
  var items = _ref.items,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? () => undefined : _ref$onChange;
  return /*#__PURE__*/_jsx(Menu, {
    items: Array.from(items.entries()).map(_ref2 => {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        isOn = _ref3[1];
      return {
        title: AdvancedSettingsMenu.getAdvancedSettingsTitleForKey(key),
        isOn,
        onChange: value => _onChange(key, value)
      };
    })
  });
}
AdvancedSettingsMenu.getAdvancedSettingsTitleForKey = key => {
  switch (key) {
    case AdvancedSettingsType.FILTER_CONTROL_CHANGE_CLEARS_ALL_FILTERS:
      return 'Clear current table filters before applying new filters from a control';
    case AdvancedSettingsType.LINK_CHANGE_CLEARS_ALL_FILTERS:
      return 'Clear current table filters before applying new filters from an incoming link filter';
  }
};
export default AdvancedSettingsMenu;
//# sourceMappingURL=AdvancedSettingsMenu.js.map